import { OfferStyles } from '@com-delta-idp/mnx-fast-action-banner-ui';
import {
  AEMBannerStyles,
  checkDefined
} from '@com-delta-idp/mnx-skymiles-shared';
import { CSSProperties } from '@com-delta-idp/mnx-ui-kit';

export const getBannerHeading1 = (
  offer: AEMBannerStyles,
  membershipLevel: string
): CSSProperties => {
  return {
    backgroundColor: getHeading1BackgroundColor(offer, membershipLevel),
    fontColor: offer.heading1?.fontColor,
    fontSize: offer.heading1?.fontSize,
    fontType: offer.heading1?.fontType
  };
};

const getHeading1BackgroundColor = (
  offer: AEMBannerStyles,
  membershipLevel: string
) => {
  if (membershipLevel === 'FF')
    return checkDefined(offer.heading1?.goldBackgroundColor);
  else if (membershipLevel === 'FO' || membershipLevel === 'GM')
    return checkDefined(offer.heading1?.platinumBackgroundColor);
  return checkDefined(offer.heading1?.reserveBackgroundColor);
};

export const getContainerStyle = (offer: AEMBannerStyles): CSSProperties => {
  return {
    ...offer.containerStyles,
    width: 'full',
    borderColor: 'none'
  };
};

export const getBannerStyle = (
  offer: AEMBannerStyles,
  membershipLevel: string
): OfferStyles => {
  return {
    annualFee: offer.annualFee,
    benefit: offer.benefit,
    bullets: offer.bullets,
    buttonLabel: offer.buttonLabel,
    checkLabel: offer.checkLabel,
    checkSectionBackgroundColor: offer.checkSectionBackgroundColor,
    containerStyles: getContainerStyle(offer),
    details: offer.details,
    heading1: getBannerHeading1(offer, membershipLevel),
    heading2: offer.heading2,
    image: offer.image,
    links: offer.linksStyles,
    actionOrientation: 'vertical'
  };
};
